import Choices from 'choices.js';

export const buildQuery = (params) => {
	// Loop through the parameters and format for the query string.
	const esc = encodeURIComponent;
	let query = Object.keys(params).map((k) => `${esc(k)}=${esc(params[k])}`);
	query = query ? `?${query.join('&')}` : '';

	return query;
};

export const setHistory = (params) => {
	const { currentUrl } = window.emOptions;
	const url = currentUrl + buildQuery(params);
	window.history.pushState({ path: url }, '', url);
};

export const getParams = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const params = {
		per_page: 10,
	};

	const wrapper = document.querySelector('.em-doctor-finder__wrapper');
	if (wrapper) {
		params.peopleTypes = wrapper.dataset.includeTypes;
	}

	urlParams.forEach((value, key) => {
		params[key] = value;
	});

	return params;
};

export const doSearch = (callback) => {
	const el = document.querySelector('.em-doctor-finder');
	if (!el) return;
	const searchField = el.querySelector('.em-doctor-finder__search-field');
	const searchFieldButton = el.querySelector('.em-doctor-finder__search button');
	const selectField = el.querySelector('.em-doctor-finder__taxonomies-field');
	const choices = new Choices(selectField); // eslint-disable-line

	const searchFieldSearch = () => {
		const params = getParams();
		params.title = searchField.value;
		choices.setChoiceByValue('');
		callback(el, params);
		setHistory(params);
	};

	searchField.addEventListener('keyup', (e) => {
		if (e.key === 'Enter') {
			searchFieldSearch();
		}
	});

	searchFieldButton.addEventListener('click', () => {
		searchFieldSearch();
	});

	selectField.addEventListener('change', function () {
		let params = getParams();
		if (params.peopleTypes) {
			params = {
				peopleTypes: params.peopleTypes,
			};
		}
		const value = this.value.split(':');
		if (value.length !== 1) {
			params[value[0]] = value[1];
		}
		searchField.value = '';
		if (params.title) {
			delete params.title;
		}
		callback(el, params);
		setHistory(params);
	});
};

export const setExisitngValues = (el, params) => {
	Object.keys(params).forEach((key) => {
		const value = params[key];
		if (key === 'title') {
			const searchInput = el.querySelector('.em-doctor-finder__search-field');
			searchInput.value = value;
		} else if (key !== 'page') {
			const termOption = el.querySelector(`.em-doctor-finder__taxonomies-field option[value="${key}:${value}"]`);
			if (termOption) {
				termOption.selected = true;
			}
		}
	});
};
